// Styles - Import this first to ensure CSS is loaded
import './styles/index.css'

// Components
// Foundations
export { default as TbModal } from './components/foundations/TbModal.vue'
export { default as TbSelect } from './components/foundations/TbSelect.vue'

// Patterns  
export { default as TbBreadcrumb } from './components/patterns/TbBreadcrumb.vue'

// Feedback
export { default as TbToast } from './components/feedback/TbToast.vue'
export { default as TbConfirmModal } from './components/feedback/TbConfirmModal.vue'

// Composables
export { useToast, toast } from './composables/useToast.js'

// Icons - Curated Lucide icons
export * from './icons/index'

// Tokens & Presets
export { default as tailwindPreset } from './tokens/tailwind.preset'

// Version
export const version = '0.1.0'